import React from "react";
import styled from "styled-components";
import NavLink from "./NavLink";

const StyledDropdownLi = styled.li`
  background: ${(props) => props.theme.colors.navBgSecond()};
`;

export default function NavBotLinks({ links }) {
  const printLinks = (links) => {
    return links.map((link) => (
      <li key={link.label}>
        <NavLink link={link} />
      </li>
    ));
  };

  const num = 6;
  const linksSlice = links.length > num ? num - 1 : num;
  const linksSliced = links.slice(0, linksSlice);

  let moreLinks = [];
  if (links.length > num) moreLinks = links.slice(num - 1);

  return (
    <ul className={"flex"}>
      {printLinks(linksSliced)}
      {moreLinks.length > 0 && (
        <StyledDropdownLi className={"dropdown"}>
          more...
          <ul className={"dropdown-content flex"}>{printLinks(moreLinks)}</ul>
        </StyledDropdownLi>
      )}
    </ul>
  );
}
